<template>
  <div class="bootstrap">
    <div class="comment-overlay" v-show="modals.overlay">
      <form class="buttons" @submit.prevent="saveComments">
        <button type="button" class="btn btn-close" @click="cancelComments">Cancel</button>
        <button type="submit" class="btn btn-success" :disabled="loading.save">
          {{ loading.save ? 'Saving comment(s)...' : 'Save comment(s)' }}
        </button>
      </form>
      <div class="commentImage">
        <div style="position: relative;">
          <img :src="commentImage"/>

          <a href="#" v-for="(comment, index) in comments" class="index"
             :style="{left: `${comment.pcX}%`, top: `${comment.pcY}%`}"
             :class="getIndexClassName(index)"
             :title="comment.comment"
             @click.prevent="editComment(index)"
          >
            {{ index + 1 }}
          </a>
        </div>
      </div>
    </div>

    <b-modal
      title="Add a comment" size="xl" v-model="modals.comment"
      :style="{position: 'absolute'}"
      id="trial-comments-modal"
      @ok="saveComment" @cancel="cancelComment" @hide="cancelComment" @shown="modalShown"
    >
      <label style="width: 100%">
        <span class="label-title">
          Screen: <b>{{ this.screen }}</b>
          <br/><br/>
        </span>
      </label>
      <label style="width: 100%">
        <span class="label-title">Please type the comment: <sup>*</sup></span>
        <textarea class="form-control comment-box" v-model="comment" ref="commentBox" style="width: 100%"></textarea>
        <br/>
      </label>
      <label style="width: 100%">
        <span class="label-title">Assign to user:</span>
        <select
          v-model="user"
          style="padding: 0 10px; width: 100%; height: 30px; margin-top: 10px;"
        >
          <option :value="null">- Unassigned -</option>
          <option
            v-for="u in users()"
            :value="u.id"
          >
            {{ u.name }}
          </option>
        </select>
      </label>
    </b-modal>
  </div>
</template>

<script>
import $ from 'jquery';
import html2canvas from 'html2canvas';
import swal from 'sweetalert';
import get from 'lodash/get';
import config from '../../../../config/config.json';
import axios from 'axios';

export default {
  props: {
    survey: {default: 0},
    treatment: {default: 0},
  },
  data() {
    return {
      screen: '',
      commentImage: null,
      comments: [],
      editingCommentId: null,
      comment: '',
      modals: {
        overlay: false,
        comment: false
      },
      loading: {
        save: false
      },
      user: null,
    }
  },
  computed: {},
  mounted() {
    if (!this.treatment) {
      console.error('no treatment value found');
    }

    const self = this;
    let script = document.createElement("script");
    script.onload = () => {
      self.onPredictivDataLoad()
    };
    script.async = true;
    script.src = `${config.dashboard.domain}/app/surveys/${this.survey}/${config.server.id}/credentials.js`;
    document.head.appendChild(script);
  },
  watch: {},
  methods: {
    onPredictivDataLoad() {
      if (window.Predictiv && window.Predictiv.treatments) {
        this.treatments = window.Predictiv.treatments;
        this.pages = window.Predictiv.pages;
      }
      if (window.Predictiv && window.Predictiv.user && window.Predictiv.user.canComment) {
        this.canComment = true;
      }

      const self = this;
      $(function () {
        self.getScreenName();

        $('.commentImage img').click(function (e) {
          var offset = $(this).offset();
          const posX = e.pageX - offset.left;
          const posY = e.pageY - offset.top;
          const pcX = parseFloat((posX / $(this).width() * 100).toFixed(2));
          const pcY = parseFloat((posY / $(this).height() * 100).toFixed(2));
          self.createComment(pcX, pcY);
        });

        $('body').on('click', '.vue-material-add-comment', function (ev) {
          const targetElem = $(this);

          ev.preventDefault();
          window.scrollTo(0, 0);

          // targetElem.imagesLoaded(function () {
          // html2canvas($('#vue-material-comments-container')[0], {
          html2canvas($('body')[0], {
            // allowTaint: true,
            logging: true,
            useCORS: true
          }).then(function (canvas) {
            self.commentImage = canvas.toDataURL();
            $('body').addClass('with-overlay');
            self.modals.overlay = true;
          }).catch(err => {
            console.log({err});
          });
          // });
        });
      });

      const canComment = get(window, 'Predictiv.user.canComment', false);
      if (canComment)
        $('.vue-material-add-comment').show();

      console.log({Predictiv: window.Predictiv})
    },
    getScreenName() {
      this.screen = $('.group-name').text();
    },
    users() {
      const users = get(window, 'Predictiv.users', []) || [];
      return users.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
    },
    createComment(pcX, pcY) {
      const comment = {
        pcX, pcY, comment: ''
      };
      this.comments.push(comment);
      this.editingCommentId = this.comments.length - 1;
      this.comment = '';
      this.modals.comment = true;
    },
    saveComment(save) {
      this.comments[this.editingCommentId].user = this.user;
      this.comments[this.editingCommentId].comment = this.comment;
      this.comment = null;
      this.editingCommentId = null;
      this.user = null;
      this.resetComments();
    },
    cancelComment(action) {
      if (action.trigger !== 'ok')
        this.resetComments();
    },
    editComment(commentId) {
      this.editingCommentId = commentId;
      this.comment = this.comments[commentId].comment;
      this.modals.comment = true;
    },
    resetComments() {
      this.comments = this.comments.filter(c => c.comment !== '');
      console.log({comments: this.comments});
    },
    getIndexClassName(index) {
      const classNames = [
        'zero', 'one', 'two', 'three', 'four'
      ];
      return null;
      // return classNames[index % classNames.length];
    },
    modalShown() {
      this.$refs.commentBox.focus();
    },
    cancelComments() {
      this.modals.overlay = false;
      $('body').removeClass('with-overlay');
    },
    saveComments() {
      this.loading.save = true;
      axios
        .put(`${config.dashboard.domain}/app/surveys/${this.survey}/${config.server.id}/threads/add`, {
          user: window.Predictiv.user.id,
          image: this.commentImage,
          comments: this.comments,
          screen: this.screen,
          treatment: this.treatment
        })
        .then(response => {
          console.log({response});
          swal({
            text: response.data.saved === 1 ?
              `${response.data.saved} comment have been successfully saved.` :
              `${response.data.saved} comments have been successfully saved.`,
            icon: "success",
          });
          this.comments = [];
          this.cancelComments();
        })
        .catch(error => {
          console.log({error});
          swal({
            text: 'Could not save the comments. Please try again.',
            icon: "error",
          });
        })
        .finally(() => this.loading.save = false);
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.comment-overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1030;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 1);
  overflow: hidden; /* Disable horizontal scroll */
  // overflow-x: hidden; /* Disable horizontal scroll */
  // overflow-y: scroll; /* Disable horizontal scroll */

  /* Position the content inside the overlay */
  .overlay-content {
    position: relative;
    // top: 25%; /* 25% from the top */
    width: 100%; /* 100% width */
    text-align: center; /* Centered text/links */
    margin-top: 30px; /* 30px top margin to avoid conflict with the close button on smaller screens */
  }

  /* The navigation links inside the overlay */
  a {
    padding: 8px;
    text-decoration: none;
    font-size: 36px;
    color: #818181;
    display: block; /* Display block instead of inline */
    transition: 0.3s; /* Transition effects on hover (color) */
  }

  /* When you mouse over the navigation links, change their color */
  a:hover, a:focus {
    color: #f1f1f1;
  }

  /* Position the close button (top right corner) */
  .closebtn {
    position: absolute;
    top: 20px;
    right: 45px;
    font-size: 60px;
  }

  /* When the height of the screen is less than 450 pixels, change the font-size of the links and position the close button again, so they don't overlap */
  @media screen and (max-height: 450px) {
    a {
      font-size: 20px
    }
    .closebtn {
      font-size: 40px;
      top: 15px;
      right: 35px;
    }
  }

  .commentImage {
    width: calc(100% - 20px);
    max-height: calc(100% - 60px);
    margin: 55px 10px 50px;
    overflow-y: scroll;
    overflow-x: hidden;
    // float: left;

    img {
      cursor: pointer;
      width: 100%;
    }
  }

  .buttons {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .index {
    cursor: pointer;
    top: 0;
    left: 0;
    position: absolute;
    display: inline-block;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-left: -16px;
    margin-top: -16px;
    padding: 6px 0;
    // background: red;
    // color: white;
    border: 1px solid white;
    background-color: #4be2c0;
    color: black;
    text-align: center;
    font: 17px Arial, sans-serif;
    margin-bottom: 10px;
    font-weight: bold;
    opacity: .7;
  }

  .comments {
    float: right;
    width: calc(20% - 10px);
    height: calc(100% - 50px);
    margin: 25px 5px;
    overflow-y: scroll;
    color: white;

    .comment {
      float: right;
      width: calc(100% - 40px);

      textarea {
        width: 100%;
        height: 70px;
        color: black;
      }
    }
  }
}

.comment-box {
  width: 90%;
  min-width: 300px;
  height: 100px;
}
</style>


<style lang="scss">
#trial-comments-modal {
  h5 {
    font-weight: bold;
    font-size: 20px;
  }

  .label-title {
    display: block;
    font-size: 16px;
    margin-bottom: 0;
  }

  textarea {
    margin-top: 10px;
  }

  & + .modal-backdrop {
    opacity: 0.5;
  }

  header.modal-header {
    .modal-title {
      display: inline-block;
    }
  }
}

body.with-overlay {
  overflow: hidden;
  height: 100%;
}

.swal-overlay {
  z-index: 2002;
}
</style>
